import { render, staticRenderFns } from "./AcceptanceContactIfDetractor.vue?vue&type=template&id=b2f45226&"
import script from "./AcceptanceContactIfDetractor.vue?vue&type=script&lang=ts&"
export * from "./AcceptanceContactIfDetractor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports